const GLOBAL_ACTIVITY_ID = 'workbench.actions.manage';
const ACCOUNTS_ACTIVITY_ID = 'workbench.actions.accounts';
export { ACCOUNTS_ACTIVITY_ID, GLOBAL_ACTIVITY_ID };
